const cleanHex = (hex) => {
  return hex.replace(/[^0-9a-f]/gi, '')
}

const validateHex = (hex) => {
  const emptyHex = hex === ''
  // when:  6 or 3 digit
  const isValidHex = hex.length === 6 || hex.length === 3

  if (!isValidHex || emptyHex) throw new Error('Invalid hex color: ' + hex)

  return hex
}

const formatSixDigitHex = (hex) => {
  if (hex.length === 3) {
    hex = hex.split('').reduce((final, char) => final + (char + char), '')
  }

  return hex
}

const convertTwoCharGroup = (hex) => {
  return hex.match(/([0-9a-f]){2}/gi)
}

const addLumiance = (luminosity) => {
  const black = 0
  const white = 255

  return (hex) => {
    const numberFromHex = parseInt(hex, 16)
    const addLuminosity = numberFromHex + white * luminosity
    const blackOrLuminosity = Math.max(black, addLuminosity)
    const partialColor = Math.min(blackOrLuminosity, white)
    const alteredColor = Math.round(partialColor)
    const numericToHex = alteredColor.toString(16)
    const formatValueWhenLessThanTwoDigits = ('0' + numericToHex).slice(-2)

    return formatValueWhenLessThanTwoDigits
  }
}

const newColor = (hex, luminosity) => {
  const r = luminosity(hex[0])
  const g = luminosity(hex[1])
  const b = luminosity(hex[2])

  return `#${r}${g}${b}`
}

const darkenLighten = (hex = '', luminosity = 0) => {
  hex = cleanHex(hex)
  hex = validateHex(hex)
  hex = formatSixDigitHex(hex)
  hex = convertTwoCharGroup(hex)
  luminosity = addLumiance(luminosity)
  hex = newColor(hex, luminosity)

  return hex
}

export const useColor = (hex = '', luminosity = 0) => {
  return darkenLighten(hex, luminosity / 100)
}
